export class ValidateSweetFaceManagerAccessPinResponseDto {
  // @ApiProperty({
  //   description: 'Pie Merchant ID',
  //   example: 7,
  // })
  pieMerchantId: number;

  // @ApiProperty({
  //   description: 'Manager Access Pin',
  //   maxLength: 6,
  //   minLength: 6,
  //   example: 456789,
  // })
  managerAccessPin: string;

  // @ApiProperty({
  //   description: 'Manager Access Pin is valid',
  // })
  isValid: boolean;
}
